export default "__VITE_ASSET__2qakyv4S__"